const STORAGE_KEY = 'hiddenActivateCpiList'

const readList = (): string[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export const isActivateCpiHidden = (cpiName: string): boolean => readList().includes(cpiName)

export const hideActivateCpi = (cpiName: string): void => {
  const list = readList()
  if (list.includes(cpiName)) return
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...list, cpiName]))
}
